import { default as login } from "./login.json";
import { default as resetPassword } from "./reset-password.json";
import { default as signupError } from "./signup-error.json";
import { default as signup } from "./signup.json";
import { default as updatePassword } from "./update-password.json";

const data = {
  "login": login,
  "reset-password": resetPassword,
  "signup": signup,
  "signup-error": signupError,
  "update-password": updatePassword,
};

const auth = {
  getResetPassword: () => data["reset-password"],
  getUpdatePassword: () => data["update-password"],
  login: () => data["login"],
  signup: () => data["signup"],
  signupError: () => data["signup-error"],
};

export default auth;
